import { useDispatch, useSelector } from "react-redux";
import {
  onFilterMenuCategory,
  onFilterMenuCombo,
} from "../store/Menu/MenuActions";
import { SORTS } from "../utils/Constants";
import useSearchHook from "./useSearchHook";
import moment from "moment";

const useSortHook = () => {
  const dispatch = useDispatch();
  const {
    category,
    comboModified,
    sortedCategoryMenu,
    sortedComboMenu,
    searchPhrase,
  } = useSelector((state) => state.menu);
  const { checkoutDetails } = useSelector((state) => state.cart);
  const { flavour } = useSelector((state) => state.app);

  const { handleCategorySearch, handleComboSearch } = useSearchHook();

  const getCategory = () => {
    //deep copy object
    return JSON.parse(JSON.stringify(sortedCategoryMenu));
  };
  const getCombo = () => {
    //deep copy object
    return JSON.parse(JSON.stringify(sortedComboMenu));
  };
  //-------------------------------------------------------category
  // default sort category
  const getDefaultSortCategory = (id) => {
    let categoryFil = getCategory();
    const catIndex = categoryFil.findIndex((c) => c.categoryId === id);
    const catDefIndex = category.findIndex((c) => c.categoryId === id);
    //if search phrase then take searched categories
    const data = searchPhrase ? handleCategorySearch(searchPhrase) : category;
    let defaultItems = [...data[catDefIndex]?.item];
    categoryFil[catIndex].item = [...defaultItems];

    return { categoryFil };
  };

  // A-Z sort category
  const getAZSortCategory = (id) => {
    let categoryFil = getCategory();
    const index = categoryFil.findIndex((c) => c.categoryId === id);
    categoryFil[index]?.item?.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    return { categoryFil };
  };

  // Z-A sort category
  const getZASortCategory = (id) => {
    let categoryFil = getCategory();
    const index = categoryFil.findIndex((c) => c.categoryId === id);
    categoryFil[index]?.item?.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();

      if (fa < fb) {
        return 1;
      }
      if (fa > fb) {
        return -1;
      }
      return 0;
    });
    return { categoryFil };
  };

  // low -high price sort category
  const getLowHighPriceSortCategory = (id) => {
    let categoryFil = getCategory();
    const index = categoryFil.findIndex((c) => c.categoryId === id);
    categoryFil[index]?.item?.sort((a, b) => {
      return a.sale_price - b.sale_price;
    });
    return { categoryFil };
  };
  // high-low price sort category
  const getHighLowPriceSortCategory = (id) => {
    let categoryFil = getCategory();
    const index = categoryFil.findIndex((c) => c.categoryId === id);
    categoryFil[index]?.item?.sort((a, b) => {
      return b.sale_price - a.sale_price;
    });
    return { categoryFil };
  };
  //---------------------------------------------------------combo
  // default sort category
  const getDefaultSortCombo = (id) => {
    const comboFil = getCombo();

    const data = searchPhrase ? handleComboSearch(searchPhrase) : comboModified;

    const comDefItems = data[id];
    comboFil[id] = comDefItems;

    return { comboFil };
  };

  // A-Z sort category
  const getAZSortCombo = (id) => {
    let comboFil = getCombo();
    comboFil[id]?.sort((a, b) => {
      let fa = a.combo_name.toLowerCase(),
        fb = b.combo_name.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    return { comboFil };
  };

  // Z-A sort category
  const getZASortCombo = (id) => {
    let comboFil = getCombo();
    comboFil[id]?.sort((a, b) => {
      let fa = a.combo_name.toLowerCase(),
        fb = b.combo_name.toLowerCase();

      if (fa < fb) {
        return 1;
      }
      if (fa > fb) {
        return -1;
      }
      return 0;
    });
    return { comboFil };
  };

  // low -high price sort category
  const getLowHighPriceSortCombo = (id) => {
    let comboFil = getCombo();
    comboFil[id]?.sort((a, b) => {
      return a.combo_price - b.combo_price;
    });
    return { comboFil };
  };
  // high-low price sort category
  const getHighLowPriceSortCombo = (id) => {
    let comboFil = getCombo();
    comboFil[id]?.sort((a, b) => {
      return b.combo_price - a.combo_price;
    });
    return { comboFil };
  };

  //-----------------------------------------handle category sort
  const handleSortCategory = (val, id) => {
    let categoryRes = [];
    if (val === SORTS.DEFAULT) {
      categoryRes = getDefaultSortCategory(id);
    } else if (val === SORTS.AZ) {
      categoryRes = getAZSortCategory(id);
    } else if (val === SORTS.ZA) {
      categoryRes = getZASortCategory(id);
    } else if (val === SORTS.LOW_HIGH_PRICE) {
      categoryRes = getLowHighPriceSortCategory(id);
    } else if (val === SORTS.HIGH_LOW_PRICE) {
      categoryRes = getHighLowPriceSortCategory(id);
    }
    dispatch(onFilterMenuCategory(categoryRes?.categoryFil));
  };

  //----------------------------------------handle combo sort
  const handleSortCombo = (val, id) => {
    let categoryRes = [];
    if (val === SORTS.DEFAULT) {
      categoryRes = getDefaultSortCombo(id);
    } else if (val === SORTS.AZ) {
      categoryRes = getAZSortCombo(id);
    } else if (val === SORTS.ZA) {
      categoryRes = getZASortCombo(id);
    } else if (val === SORTS.LOW_HIGH_PRICE) {
      categoryRes = getLowHighPriceSortCombo(id);
    } else if (val === SORTS.HIGH_LOW_PRICE) {
      categoryRes = getHighLowPriceSortCombo(id);
    }
    dispatch(onFilterMenuCombo(categoryRes?.comboFil));
  };

  const checkProductAvailability = (product, currentTime) => {
    const momentCurrentTime = moment(currentTime);
    if (product == null) {
      return true;
    }
    const availabilityRules = product?.availability;

    if (
      typeof availabilityRules === "string" &&
      availabilityRules !== undefined &&
      availabilityRules !== null
    ) {
      availabilityRules = JSON.parse(availabilityRules);
    }
    if (
      availabilityRules &&
      availabilityRules?.length > 0 &&
      availabilityRules !== undefined
    ) {
      for (const rule of availabilityRules) {
        // app check
        let domain = "ONLINE_DELIVERY";

        if (
          flavour === "ONLINE_ORDER" &&
          checkoutDetails?.orderType === "DELIVERY"
        ) {
          domain = "ONLINE_DELIVERY";
        } else if (
          flavour === "ONLINE_ORDER" &&
          checkoutDetails?.orderType === "PICKUP"
        ) {
          domain = "ONLINE_PICKUP";
        } else if (flavour === "TABLE") {
          domain = "TABLE_SIDE";
        }
        if (rule?.DM) {
          const isAvailable = rule?.DM?.includes(domain);
          if (!isAvailable) {
            continue; // Skip to the next rule if online delivery is not available
          }
        }

        // date check
        if (rule?.SD && rule?.ED) {
          const startDate = moment(rule.SD, "YYYY-MM-DD");
          const endDate = moment(rule?.ED, "YYYY-MM-DD");

          if (
            momentCurrentTime.isBefore(startDate) ||
            momentCurrentTime.isAfter(endDate)
          ) {
            continue;
          }
        }

        // week day check
        if (rule?.D) {
          const currentWeekDay = momentCurrentTime.format("d");
          if (!rule?.D?.includes(currentWeekDay)) {
            continue;
          }
        }

        // Time check
        if (rule?.H) {
          const currentTimeStr = moment(
            momentCurrentTime.format("HH:mm"),
            "HH:mm"
          );
          // Iterate over each time range in the rule.hours array
          for (const timeRange of rule?.H) {
            // Check if the current time falls within the current time range
            const startTime = moment(timeRange.S, "HH:mm");
            const endTime = moment(timeRange.E, "HH:mm");

            if (
              currentTimeStr.isAfter(startTime) &&
              currentTimeStr.isBefore(endTime)
            ) {
              return true; // Return true if current time is within any time range
            }
          }
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
    return false;
  };

  const checkComboCatAvailability = (product, currentTime) => {
    // console.log("categoryyyyy", product);
    const momentCurrentTime = moment(currentTime);
    if (product == null) {
      return true;
    }
    const availabilityRules = product?.category_availability;

    if (
      typeof availabilityRules === "string" &&
      availabilityRules !== undefined &&
      availabilityRules !== null
    ) {
      availabilityRules = JSON.parse(availabilityRules);
    }

    if (
      availabilityRules &&
      availabilityRules?.length > 0 &&
      availabilityRules !== undefined
    ) {
      for (const rule of availabilityRules) {
        // app check
        let domain = "ONLINE_DELIVERY";

        if (
          flavour === "ONLINE_ORDER" &&
          checkoutDetails?.orderType === "DELIVERY"
        ) {
          domain = "ONLINE_DELIVERY";
        } else if (
          flavour === "ONLINE_ORDER" &&
          checkoutDetails?.orderType === "PICKUP"
        ) {
          domain = "ONLINE_PICKUP";
        } else if (flavour === "TABLE") {
          domain = "TABLE_SIDE";
        }
        if (rule?.DM) {
          const isAvailable = rule?.DM?.includes(domain);
          if (!isAvailable) {
            continue; // Skip to the next rule if online delivery is not available
          }
        }

        // date check
        if (rule?.SD && rule?.ED) {
          const startDate = moment(rule.SD, "YYYY-MM-DD");
          const endDate = moment(rule?.ED, "YYYY-MM-DD");

          if (
            momentCurrentTime.isBefore(startDate) ||
            momentCurrentTime.isAfter(endDate)
          ) {
            continue;
          }
        }

        // week day check
        if (rule?.D) {
          const currentWeekDay = momentCurrentTime.format("d");
          if (!rule?.D?.includes(currentWeekDay)) {
            continue;
          }
        }

        // Time check
        if (rule?.H) {
          const currentTimeStr = moment(
            momentCurrentTime.format("HH:mm"),
            "HH:mm"
          );
          // Iterate over each time range in the rule.hours array
          for (const timeRange of rule?.H) {
            // Check if the current time falls within the current time range
            const startTime = moment(timeRange.S, "HH:mm");
            const endTime = moment(timeRange.E, "HH:mm");
            if (
              currentTimeStr.isAfter(startTime) &&
              currentTimeStr.isBefore(endTime)
            ) {
              return true; // Return true if current time is within any time range
            }
          }
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
    return false;
  };

  //return hook
  return {
    handleSortCategory,
    checkProductAvailability,
    handleSortCombo,
    checkComboCatAvailability,
  };
};

export default useSortHook;
